import { SymbolType } from "@lib/titan2-slingo/dist/api/model/enum/SymbolType";
import { SolidifyableData } from "@lib/titan2/dist/api/core/data/SolidifyableData";
import { ApiConstants } from "../enum/ApiConstants";
export class WinLineFeatureConfigData extends SolidifyableData {
    constructor(data) {
        super(data);
        this.solidify();
    }
    solidify() {
        super.solidify();
        if (this.dataExists(this.data)) {
            this.numberMultipliers = this.solidifyMultipliers(this.data.getDataObject(ApiConstants.PROPERTY_WIN_LINES_NUMBERS));
            this.jokerMultipliers = this.solidifyMultipliers(this.data.getDataObject(ApiConstants.PROPERTY_WIN_LINES_JOKERS));
        }
        else {
            this.numberMultipliers = [];
            this.jokerMultipliers = [];
        }
    }
    solidifyMultipliers(data) {
        if (this.dataExists(data)) {
            // Fill multipliers from the object, which is a Record<string, string> of number of symbols to multiplier.
            const multipliers = [];
            const obj = data.toObject();
            for (const [key, value] of Object.entries(obj)) {
                const numberOfSymbols = parseInt(key, 10);
                const multiplier = parseFloat(value);
                multipliers[numberOfSymbols - 1] = multiplier;
            }
            // Fill empty multipliers with 0.
            for (let i = 0; i < multipliers.length; ++i) {
                if (isNaN(multipliers[i])) {
                    multipliers[i] = 0;
                }
            }
            return multipliers;
        }
        return [];
    }
    getMultipliers(symbolType) {
        switch (symbolType) {
            case SymbolType.SUPER_JOKER:
            case SymbolType.JOKER:
                return this.jokerMultipliers;
            case SymbolType.NUMBER:
                return this.numberMultipliers;
            default:
                return [];
        }
    }
    getThreshold(symbolType) {
        return this.getMultipliers(symbolType).findIndex((multiplier) => multiplier > 0);
    }
}
//# sourceMappingURL=WinLineFeatureConfigData.js.map